import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { DynaDocsModelRepository } from '@/store/dyna-docs-model-state/dyna-docs-model-state.repository';

interface IGetDynaDocsModelAddDrawerObjectProps {
  store: DynaDocsModelRepository;
  formObject: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getDynaDocsModelAddDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: IGetDynaDocsModelAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.dynaDocsModels.add.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: { formObject },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.dynaDocsModels.add.add',
        onClick: () => action?.(),
      },
      {
        label: 'settings.dynaDocsModels.add.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
